import React from 'react'; 
import PropTypes from 'prop-types';

const SectionHeader = ({title, required}) => {
  return (
    <h4 className={required ? 'label-required text-primary' : 'text-primary'}>
       <span dangerouslySetInnerHTML={{ __html: title }} />
    </h4>
  );
};

SectionHeader.propTypes = {
  title: PropTypes.string,
  required: PropTypes.bool
};

export default SectionHeader;